import {AuwCookieBanner} from "./AuwCookieBanner";
import {AuwResetCookieChoice} from "./AuwResetCookieChoice";


if($('.cookie-banner').length) {
    $.each($('.cookie-banner'),function(i,e) {
        new AuwCookieBanner($(e));
    });
}
if($('.cookie-banner__re-opt-in').length) {
    $.each($('.cookie-banner__re-opt-in'),function(i,e) {
        new AuwResetCookieChoice($(e));
    });
}


